export default __webpack_public_path__ + "static/attribute_dont-ff8e77d202d1fbfe236963cd3eaae04a.png";